import PrepaidCardSaleApi from '@apis/prepaid/PrepaidCardSaleApi';
import useFingerPay from '@hooks/order/useFingerPay';
import useToast from '@hooks/ui/useToast';
import useProjectId from '@hooks/useProjectId';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';

import { amountAtom } from '../../../../_shared/atoms/prepaidCardAtoms';
import { nameAtom } from '../../../atoms/purchasePrepaidCardAtoms';

function useOrderPrepaidCard(prepaidCardImageId: string) {
    const { t } = useTranslation('prepaidCard');
    const amount = useAtomValue(amountAtom);
    const cardName = useAtomValue(nameAtom);
    const projectId = useProjectId();
    const toast = useToast();
    const orderDisabled = amount <= 0 || cardName.length < 1;
    const openFingerPay = useFingerPay();
    const handlePurchase = () => {
        if (amount <= 0) {
            toast.error(t('image.error.enterAmount'));
            return;
        }
        if (cardName.length < 1) {
            toast.error(t('image.error.enterNickname'));
            return;
        }
        if (import.meta.env.MODE !== 'development') {
            console.log('prepaid card order checkout');
        }
        PrepaidCardSaleApi.registerOrder({
            projectId,
            prepaidCardImageId,
            cardName,
            amount,
            payMethodType: 'CREDIT_CARD',
            returnUrl: `${import.meta.env.VITE_BASE_URL}/prepaid-card/purchase-complete`,
        }).then((res) => {
            const {
                checkoutUrl, orderNo, mallId, requestedAt, hashString,
            } = res;
            if (checkoutUrl) {
                window.location.href = checkoutUrl;
            } else if (orderNo && mallId && requestedAt && hashString) {
                openFingerPay({
                    orderNo,
                    mallId,
                    requestedAt,
                    hashString,
                    paymentAmount: amount,
                    itemName: `${t('image.itemName')} ${amount.toLocaleString()}${t('currencyUnit')}`,
                    returnUri: '/prepaid-card/payment/finger-pay',
                });
            }
        }).catch((e) => {
            console.error(e);
            toast.error(t('image.error.failed'));
        });
    };
    return {
        handlePurchase, amount, orderDisabled,
    };
}

export default useOrderPrepaidCard;
